export default "__VITE_ASSET__c03fdd59__"